<template>
  <section class="sit-section" aria-labelledby="sit-heading">
    <div class="max-w-screen-xl mx-auto px-6">

      <div class="sit-head">
        <span class="sit-eyebrow">Voor jouw situatie</span>
        <h2 id="sit-heading" class="sit-title">Waar wil je mee beginnen?</h2>
        <p class="sit-sub">Kies je situatie en we helpen je in een paar klikken naar de juiste oplossing.</p>
      </div>

      <ul class="sit-grid" role="list">
        <li v-for="s in situaties" :key="s.to">
          <router-link :to="s.to" class="sit-card">
            <span class="sit-icon" aria-hidden="true"><i :class="`bi ${s.icon}`"></i></span>
            <span class="sit-card-body">
              <span class="sit-card-title">{{ s.title }}</span>
              <span class="sit-card-desc">{{ s.desc }}</span>
            </span>
            <span class="sit-arrow" aria-hidden="true">
              <i class="bi bi-arrow-right"></i>
            </span>
          </router-link>
        </li>
      </ul>

      <p class="sit-more">
        Twijfel je nog?
        <router-link to="/keuzehulp" class="sit-more-link">Doe de volledige keuzehulp</router-link>.
      </p>

    </div>
  </section>
</template>

<script setup>
const situaties = [
  {
    icon: 'bi-sun',
    title: 'Stroom opwekken op je balkon of dak',
    desc: 'Plug & play zonnepanelen, óók als je huurt. Ophangen, inpluggen en direct besparen.',
    to: '/keuzehulp/zonnepanelen',
  },
  {
    icon: 'bi-ev-station',
    title: 'Je elektrische auto thuis opladen',
    desc: 'Een slimme, betrouwbare laadpaal die past bij je auto en je meterkast.',
    to: '/keuzehulp/laadpaal',
  },
  {
    icon: 'bi-battery-charging',
    title: 'Energie opslaan voor ’s avonds',
    desc: 'Bewaar je zonnestroom en gebruik ’m wanneer jij wilt. Minder afhankelijk van het net.',
    to: '/keuzehulp/thuisbatterij',
  },
]
</script>

<style scoped>
.sit-section {
  padding: 5rem 0;
  background: #f8f8f8;
}

.sit-head {
  text-align: center;
  max-width: 620px;
  margin: 0 auto 3rem;
}

.sit-eyebrow {
  display: inline-block;
  background: rgba(255, 213, 0, 0.15);
  color: #7a5f00;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.3rem 1rem;
  border-radius: 50px;
  border: 1px solid rgba(255, 213, 0, 0.3);
  margin-bottom: 1.25rem;
}

.sit-title {
  font-size: clamp(1.625rem, 3vw, 2.25rem);
  font-weight: 900;
  color: #111;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin: 0 0 0.75rem;
  text-wrap: balance;
}

.sit-sub {
  font-size: 1.0625rem;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.sit-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

.sit-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  height: 100%;
  background: #fff;
  border: 1px solid #e9eaec;
  border-radius: 4px;
  padding: 1.75rem;
  text-decoration: none;
  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;
}
.sit-card:hover {
  border-color: #FFD500;
  box-shadow: 0 2px 10px rgba(17, 17, 17, 0.06);
  transform: translateY(-2px);
}

.sit-icon {
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  background: #111;
  color: #FFD500;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
}

.sit-card-body { flex: 1; min-width: 0; }

.sit-card-title {
  display: block;
  font-size: 1rem;
  font-weight: 800;
  color: #111;
  line-height: 1.3;
  margin-bottom: 0.4rem;
}

.sit-card-desc {
  display: block;
  font-size: 0.875rem;
  color: #666;
  line-height: 1.6;
}

.sit-arrow {
  flex-shrink: 0;
  color: #b8860b;
  font-size: 1rem;
  transition: transform 0.2s;
  align-self: center;
}
.sit-card:hover .sit-arrow { transform: translateX(3px); }

.sit-more {
  text-align: center;
  margin: 2.5rem 0 0;
  font-size: 0.95rem;
  color: #666;
}
.sit-more-link {
  color: #111;
  font-weight: 700;
  text-decoration: none;
  border-bottom: 2px solid #FFD500;
  padding-bottom: 1px;
}

@media (max-width: 900px) {
  .sit-grid { grid-template-columns: 1fr; gap: 1rem; }
}

@media (prefers-reduced-motion: reduce) {
  .sit-card, .sit-arrow { transition: none; }
}
</style>
